
export default {
    name: "ProductFeatureCompact",
    props: {
        index: {
            type: Number,
            required: false,
        },
        lastFeatureIndex: {
            type: Number,
            required: false,
        }
    },
    computed: {
        isFirstFeature() {
            if (this.index == 0) {
                return true;
            }
            return false;
        },
        isLastFeature() {
            if (this.index == this.lastFeatureIndex) {
                return true;
            }
            return false;
        }
    }
}
